module.exports = __webpack_public_path__ + "static/Prince-51ca0cae40bdb6a15047512c007135f0.jpg";